import { gridTpl } from '../../../../../common/grid/grid.controller';

export const protectiveEquipmentHistoryGrid = {
    bindings: {
        onSelect: '&'
    },
    controller: 'ProtectiveEquipmentHistoryGridController',
    ...gridTpl
};
